import { usePlanStore, type Plan } from "../planStore";
import { useAuthStore } from "../authStore";

const PLAN_LABELS: Record<Plan, string> = {
  free: "Free",
  personal: "Personal",
  team: "Team",
};

const PLAN_CLASSES: Record<Plan, string> = {
  free: "text-zinc-600",
  personal: "text-brand",
  team: "text-warning",
};

export function PlanBadge() {
  const plan = usePlanStore((s) => s.plan);
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  if (!isAuthenticated || plan === "free") return null;

  return (
    <span className={`text-[10px] font-semibold uppercase tracking-wide ${PLAN_CLASSES[plan]}`}>
      {PLAN_LABELS[plan]}
    </span>
  );
}
